// verify-timesheet-view.component.ts
import { AddTimesheetService } from "@/services/add-timesheet/add-timesheet.service";
import { CalendarService } from "@/services/calendar/calendar.service";
import { ProjectService } from "@/services/project/project.service";
import { SessionTimeoutService } from "@/services/session-timeout/session-timeout.service";
import { UserService } from "@/services/user/user.service";
import { VerifyTimesheetViewService } from "@/services/verify-timesheet/verify-timesheet-view.service";
import { Location } from '@angular/common';
import { VerifyTimesheetService } from "@/services/verify-timesheet/verify-timesheet.service";
import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { forkJoin } from "rxjs";
import { map } from "rxjs/operators";
import Swal from "sweetalert2";
import * as XLSX from "xlsx-js-style";
import { MainTimesheet } from "../../class/main-timesheet";
import { Timesheet } from "../../class/timesheet";

@Component({
  selector: "app-verify-timesheet-view",
  templateUrl: "./verify-timesheet-view.component.html",
  styleUrls: ["./verify-timesheet-view.component.scss"],
})
export class VerifyTimesheetViewComponent implements OnInit {
  @ViewChild("closebutton") closebutton;
  @ViewChild("tooltipTemplate", { static: true }) tooltipTemplate: any;

  currentSelectedPage: number = 0; //หน้าที่กำลังเปิด
  pageSize: number = 10; //ขนาดข้อมูลในหน้า
  pageSizeforexport: number = 31; //ขนาดข้อมูลในการExport excel
  totalPages: number; //จำนวนหน้าทั้งหมดของข้อมูล
  indexpagingstart: number; //index เริ่มต้นของหน้า
  pageIndexes: Array<number> = []; //ลำดับ index ของหน้า
  rolename = localStorage.getItem("roleName");
  currentUserID = parseInt(localStorage.getItem("UserId"));

  maintimesheetId = parseInt(
    this._activatedRouter.snapshot.paramMap.get("id")!
  );

  searchvalue: string;
  searchStartTime = "00:00";
  searchEndTime = "23:59";
  searchDate = "";
  searchStartDateValue = "";
  searchEndDateValue = "";
  searchStartDate = ""; // For native date input
  searchEndDate = ""; // For native date input

  timesheets: Array<Timesheet> = [];
  //for export excel
  timesheetexport: Array<Timesheet> = [];
  mainTimesheets = new MainTimesheet();
  manday: number = 0;
  reason: string;
  statusSelected: string;
  selectreject: MainTimesheet;
  vacationList: any = [];
  checkMandayProject: any[];
  projectRemainingManday: any[] = [];
  checkProjectManday: any[] = [];

  _userMainTimesheetList!: MainTimesheet[];
  userId = localStorage.getItem("UserId");

  projectNames: any[];
  currentTabProject = "";
  invalidEmail = false;
  // Search
  isSearch: boolean = false;
  currentSearch = "";

  closeModal: string;

  // Column name
  booleanValue: any = false;
  colSort = "transDate";
  colId = "id";
  colTransDate = "transDate";
  colTimeFrom = "timeFrom";
  colTimeTo = "timeTo";
  colWorkingHours = "workingHours";
  colProjectName = "projectId.projectName";
  colDescription = "description";
  pagingLength = 0;
  currentPage = 0;
  firstnameTimesheet: any;
  lastnameTimesheet: any;
  positionNameTimesheet: any;
  //แสดงวันปัจจุบัน
  currentDate: Date = new Date();
  // Pagination table
  startIndex = 0;
  dataLength = 0;
  //selectedPage
  selectedPage: number = 0;

  sumCost = 0;
  projects: any[] = [];
  duplicateDays: { [formattedDate: string]: boolean } = {};

  currentEditingCard: any = null;
  originalCardStates = new Map<any, any>();

  // Validation for incomplete days
  workDate: { year: number; month: number; date: number }[] = [];
  dateNotYet: any[] = [];
  dateNotYetThisMonth: any[] = [];
  dateNotYetLastMonth: any[] = [];
  isSubmitBtnDisabled: boolean = true; // true means button enabled, false means disabled

  // Flags to track data loading status
  private isMainTimesheetLoaded = false;
  private isVacationListLoaded = false;
  private isExportDataLoaded = false;

  // Mobile inline form properties
showMobileAddForm = false;
mobileFormCards: any[] = [];
existingMobileTimesheetCards: any[] = [];
nextCardId = 0;
isMobileView = false;

// Bottom Sheet properties
isMobileBottomSheetOpen = false;
incompleteMobileDates: Date[] = [];
partialFilledMobileDates: any[] = [];

isReasonInvalid = false;

// Inline Edit properties for mobile
originalMobileCardStates = new Map<any, any>();

  roleId = [];
  constructor(
    private _service: VerifyTimesheetViewService,
    private route: Router,
    private _activatedRouter: ActivatedRoute,
    private service: VerifyTimesheetService,
    private sessionTimeoutService: SessionTimeoutService,
    private calendaService: CalendarService,
    private userService: UserService,
    private mainTimesheetService: AddTimesheetService,
    private modalService: NgbModal,
    private projectService: ProjectService,
    private location: Location
  ) {}



goBack() {
  this.location.back();
}

// Toggle bottom sheet for description
toggleMobileBottomSheet() {
  this.isMobileBottomSheetOpen = !this.isMobileBottomSheetOpen;

  if (this.isMobileBottomSheetOpen) {
    if (!this.showMobileAddForm) {
      // Add mode - update validation data
      this.updateMobileIncompleteData();
    } else {
      // View mode - update timesheet details if needed
      this.checkCountAllTimeSheet();
    }
  }
}

// Check if user can see action buttons
canShowActionButtons(): boolean {
  const isAdmin = this.rolename.includes('ADMIN');
  const isManager = this.rolename.includes('MANAGER');
  const isLead = this.mainTimesheets.leadId == this.currentUserID;
  const status = this.mainTimesheets.status;

  if (isAdmin) {
    return status == 'P' || status == 'M' || status == 'A' || 
           (status == 'H' && isLead);
  }

  if (isManager) {
    return status == 'P' || status == 'H';
  }

  return status == 'H' && isLead;
}

// Check if mobile view
checkMobileView() {
  this.isMobileView = window.innerWidth < 768;

  if(this.isMobileView) {
    this.loadExistingTimesheetsForMobile()
  }
}

openMobileAddForm() {
  this.showMobileAddForm = false;
  this.mobileFormCards = [];
  this.addNewMobileCard(); // เพิ่มการ์ดแรก
}

cancelMobileAddForm() {
  this.showMobileAddForm = true;
  this.mobileFormCards = [];
  // ไม่ต้องแตะ existingMobileTimesheetCards
}
// Add mobile form card
addMobileFormCard(date?: Date) {
  const cardDate = date || null;
  const cardDateStr = cardDate ? moment(cardDate).format('YYYY-MM-DD') : '';

  // Check if date is within timesheet period
  if (cardDate && !this.isDateWithinPeriod(cardDate)) {
    Swal.fire({
      title: 'Error',
      text: 'Selected date is not within the timesheet period',
      icon: 'error',
      confirmButtonText: 'OK',
      confirmButtonColor: '#00c851',
    });
    return;
  }

  const newCard = {
    id: this.nextCardId++,
    date: cardDate,
    dateStr: cardDateStr,
    projectName: '',
    projectId: 0,
    startTime: '09:00',
    endTime: '18:00',
    workingHours: 8,
    isBreak: true,
    checkOnsite: false,
    siteId: null,
    description: '',
    projectSites: [],
    selectedProject: null
  };

  this.mobileFormCards.push(newCard);
}

// Add new empty mobile card
addNewMobileCard() {
  this.addMobileFormCard();
}

// Remove mobile card
removeMobileCard(cardId: number) {
  this.mobileFormCards = this.mobileFormCards.filter(card => card.id !== cardId);

  if (this.mobileFormCards.length === 0) {
    this.addNewMobileCard();
  }
}

// Mobile project change handler
onMobileProjectChange(card: any) {
  const selectedProject = this.projects.find(p => p.projectName === card.projectName);
  if (selectedProject) {
    card.projectId = selectedProject.id;
    card.selectedProject = selectedProject;
    card.checkOnsite = false;
    card.siteId = null;
    card.projectSites = selectedProject.msProjectSites || [];
  }
}

// Mobile time change handler
onMobileTimeChange(card: any) {
  if (!card.startTime || !card.endTime) return;

  const start = moment(card.startTime, 'HH:mm');
  const end = moment(card.endTime, 'HH:mm');

  const diff = end.diff(start, 'hours', true);
  card.workingHours = card.isBreak ? diff - 1 : diff;

  if (card.workingHours < 0) {
    card.workingHours = 0;
  }
}

// Mobile break change handler
onMobileBreakChange(card: any) {
  this.onMobileTimeChange(card);
}

// Mobile onsite change handler
onMobileOnsiteChange(card: any) {
  if (!card.checkOnsite) {
    card.siteId = null;
  }
}

// Mobile date change handler
onMobileDateChange(card: any, newDate: string) {
  const date = moment(newDate).toDate();
  if (this.isDateWithinPeriod(date)) {
    card.date = date;
    card.dateStr = moment(card.date).format('YYYY-MM-DD');
  } else {
    Swal.fire({
      title: 'Error',
      text: 'Selected date is not within the timesheet period',
      icon: 'error',
      confirmButtonText: 'OK',
      confirmButtonColor: '#00c851',
    });
    card.dateStr = moment(card.date).format('YYYY-MM-DD');
  }
}

// Check if date is within timesheet period
isDateWithinPeriod(date: Date): boolean {
  const periodFrom = moment(this.mainTimesheets.preriodFrom).startOf('day');
  const periodTo = moment(this.mainTimesheets.preriodTo).endOf('day');
  const checkDate = moment(date);
  return checkDate.isSameOrAfter(periodFrom) && checkDate.isSameOrBefore(periodTo);
}

// Get min date for mobile date input
getMobileMinDate(): string {
  return moment(this.mainTimesheets.preriodFrom).format('YYYY-MM-DD');
}

// Get max date for mobile date input
getMobileMaxDate(): string {
  return moment(this.mainTimesheets.preriodTo).format('YYYY-MM-DD');
}

// Validate mobile form before save
isMobileSaveValid(): boolean {
  if (this.mobileFormCards.length === 0) return false;

  return this.mobileFormCards.every(card => {
    if (!card.dateStr || !card.date) return false;
    if (!this.isDateWithinPeriod(card.date)) return false;
    if (!card.projectName || !card.startTime || !card.endTime) return false;
    if (card.checkOnsite && card.selectedProject?.msProjectSites?.length > 0 && !card.siteId) {
      return false;
    }
    if (card.workingHours <= 0) return false;
    return true;
  });
}

saveMobileForm() {
  if (!this.isMobileSaveValid()) {
    const invalidCards = this.mobileFormCards.filter(card => {
      if (!card.dateStr || !card.date) return true;
      if (!this.isDateWithinPeriod(card.date)) return true;
      if (!card.projectName || !card.startTime || !card.endTime) return true;
      if (card.checkOnsite && card.selectedProject?.msProjectSites?.length > 0 && !card.siteId) return true;
      if (card.workingHours <= 0) return true;
      return false;
    });

    let errorMessage = 'Please fill in all required fields correctly:\n';
    invalidCards.forEach((card, idx) => {
      if (!card.dateStr) errorMessage += `\n- Card ${idx + 1}: Date is required`;
      else if (!this.isDateWithinPeriod(card.date)) errorMessage += `\n- Card ${idx + 1}: Date is not within timesheet period`;
      if (!card.projectName) errorMessage += `\n- Card ${idx + 1}: Project is required`;
      if (card.checkOnsite && !card.siteId) errorMessage += `\n- Card ${idx + 1}: Site is required when Onsite is checked`;
    });

    Swal.fire({
      title: 'Validation Error',
      text: errorMessage,
      icon: 'error',
      confirmButtonText: 'OK',
      confirmButtonColor: '#00c851',
    });
    return;
  }

  Swal.fire({
    title: 'Saving...',
    text: 'Please wait while we save your timesheets',
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading()
  });

  const timesheets: any[] = this.mobileFormCards.map(card => {
    const dateStr = moment(card.date).format('YYYY-MM-DD');
    const selectedProject = this.projects.find(p => p.projectName === card.projectName);

    return {
      mainTimesheetId: this.maintimesheetId,
      employeeId: this.mainTimesheets.employeeId,
      // บวก 7 ชั่วโมงทุก field
      timeFrom: moment.tz(`${dateStr} ${card.startTime}`, 'YYYY-MM-DD HH:mm', 'Asia/Bangkok').add(7, 'hours').toDate(),
      timeTo: moment.tz(`${dateStr} ${card.endTime}`, 'YYYY-MM-DD HH:mm', 'Asia/Bangkok').add(7, 'hours').toDate(),
      timeFromStr: card.startTime,
      timeToStr: card.endTime,
      transDate: moment.tz(dateStr, 'Asia/Bangkok').startOf('day').add(7, 'hours').toDate(),
      workingHours: card.workingHours,
      projectName: card.projectName,
      projectId: card.projectId || selectedProject?.id || 0,
      checkOnsite: card.checkOnsite,
      description: card.description || '',
      isBreak: card.isBreak,
      cost: null,
      siteId: card.siteId ? parseInt(card.siteId) : null,
      siteName: '',
      projectSites: card.siteId && card.selectedProject ?
        card.selectedProject.msProjectSites?.filter((site: any) =>
          (site.id || site.siteId) === parseInt(card.siteId)
        ) || [] : []
    };
  });

  const savePromises = timesheets.map(ts =>
    this.mainTimesheetService.addTimesheet(ts).toPromise()
  );

  Promise.all(savePromises).then(results => {
    const allSuccess = results.every(result => result !== false);

    if (allSuccess) {
      Swal.fire({
        title: 'Success!',
        text: `${timesheets.length} timesheet(s) saved successfully`,
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#00c851',
      });

      // ปิด add form mode และกลับไปแสดง existing cards
      this.cancelMobileAddForm();
      
      // Refresh data
      this.loadExistingTimesheetsForMobile();
      this.getDataByFilterWithPaging();
      this.getDataByFilterWithPagingforexport();
      this.findMainTimesheet();
    } else {
      Swal.fire({
        title: 'Error',
        text: 'Some timesheets failed to save. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });
    }
  }).catch(error => {
    console.error('Error saving timesheets:', error);
    Swal.fire({
      title: 'Error',
      text: 'Failed to save timesheets. Please try again.',
      icon: 'error',
      confirmButtonText: 'OK',
      confirmButtonColor: '#d33',
    });
  });
}




// Start editing mobile card
startEditingMobileCard(card: any) {
  const timesheetId = card.timesheetId || card.id;

  if (!timesheetId || timesheetId.toString().startsWith('existing_')) {
    Swal.fire({
      title: 'Error',
      text: 'Cannot edit this timesheet. Please try again later.',
      icon: 'error',
      confirmButtonText: 'OK',
      confirmButtonColor: '#d33',
    });
    return;
  }

  if (card.canAction === undefined) {
    card.canAction = true;
  }

  this.originalMobileCardStates.set(card, { ...card });
  card.isEditing = true;
}

// Cancel editing mobile card
cancelEditingMobileCard(card: any) {
  const original = this.originalMobileCardStates.get(card);
  if (original) {
    Object.assign(card, original);
    this.originalMobileCardStates.delete(card);
  }
  card.isEditing = false;
}

// Save edited mobile timesheet
saveEditedMobileTimesheet(card: any) {
  if (!card.canAction) {
    Swal.fire({
      title: 'Cannot Edit',
      text: 'This timesheet cannot be edited due to its current status.',
      icon: 'warning',
      confirmButtonText: 'OK',
      confirmButtonColor: '#00c851',
    });
    return;
  }

  if (!card.projectName || !card.startTime || !card.endTime) {
    Swal.fire({
      title: 'Validation Error',
      text: 'Please fill in all required fields.',
      icon: 'error',
      confirmButtonText: 'OK',
      confirmButtonColor: '#00c851',
    });
    return;
  }

  if (card.checkOnsite && card.selectedProject?.msProjectSites?.length > 0 && !card.siteId) {
    Swal.fire({
      title: 'Validation Error',
      text: 'Please select a site when Onsite is checked.',
      icon: 'error',
      confirmButtonText: 'OK',
      confirmButtonColor: '#00c851',
    });
    return;
  }

  if (card.workingHours <= 0) {
    Swal.fire({
      title: 'Validation Error',
      text: 'Working hours must be greater than 0.',
      icon: 'error',
      confirmButtonText: 'OK',
      confirmButtonColor: '#00c851',
    });
    return;
  }

  Swal.fire({
    title: 'Saving...',
    text: 'Please wait while we save your changes',
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });

  const dateStr = moment(card.date).format('YYYY-MM-DD');
  const selectedProject = this.projects.find(p => p.projectName === card.projectName);

  const updatedTimesheet: any = {
    id: card.timesheetId,
    mainTimesheetId: this.maintimesheetId,
    employeeId: this.mainTimesheets.employeeId,
    timeFrom: moment.tz(`${dateStr} ${card.startTime}`, 'YYYY-MM-DD HH:mm', 'Asia/Bangkok').toDate(),
    timeTo: moment.tz(`${dateStr} ${card.endTime}`, 'YYYY-MM-DD HH:mm', 'Asia/Bangkok').toDate(),
    timeFromStr: card.startTime,
    timeToStr: card.endTime,
    transDate: moment.tz(dateStr, 'Asia/Bangkok').startOf('day').toDate(),
    workingHours: card.workingHours,
    projectName: card.projectName,
    projectId: card.projectId || selectedProject?.id || 0,
    checkOnsite: card.checkOnsite,
    description: card.description || '',
    isBreak: card.isBreak,
    cost: null,
    siteId: card.siteId ? parseInt(card.siteId) : null,
    siteName: '',
    projectSites: card.siteId && card.selectedProject ?
      card.selectedProject.msProjectSites?.filter((site: any) =>
        (site.id || site.siteId) === parseInt(card.siteId)
      ) || [] : []
  };

  this._service.updateTimesheetToRemote(updatedTimesheet).subscribe(
    (result) => {
      if (result !== false) {
        Swal.fire({
          title: 'Success!',
          text: 'Timesheet updated successfully',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#00c851',
        });

        Object.assign(card, {
          projectName: card.projectName,
          projectId: card.projectId,
          startTime: card.startTime,
          endTime: card.endTime,
          workingHours: card.workingHours,
          isBreak: card.isBreak,
          checkOnsite: card.checkOnsite,
          siteId: card.siteId,
          description: card.description,
          selectedProject: card.selectedProject,
          isEditing: false
        });

        this.originalMobileCardStates.delete(card);
        
        // Refresh data
        this.getDataByFilterWithPaging();
        this.getDataByFilterWithPagingforexport();
        this.findMainTimesheet();
      } else {
        Swal.fire({
          title: 'Error',
          text: 'Failed to update timesheet. Please try again.',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
      }
    },
    (error) => {
      console.error('Error updating timesheet:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to update timesheet. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });
    }
  );
}

// Delete mobile timesheet with confirmation
deleteMobileTimesheetConfirm(card: any) {
  Swal.fire({
    title: 'Are you sure?',
    text: 'Do you want to delete this timesheet?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, Delete it!',
    cancelButtonText: 'Cancel'
  }).then((result) => {
    if (result.isConfirmed) {
      this.deleteMobileTimesheet(card);
    }
  });
}

// Delete mobile timesheet
deleteMobileTimesheet(card: any) {
  const timesheetId = card.timesheetId;

  if (!timesheetId || timesheetId.toString().startsWith('existing_')) {
    Swal.fire({
      title: 'Error',
      text: 'Cannot delete this timesheet. Invalid timesheet ID.',
      icon: 'error',
      confirmButtonText: 'OK',
      confirmButtonColor: '#d33',
    });
    return;
  }

  Swal.fire({
    title: 'Deleting...',
    text: 'Please wait while we delete this timesheet',
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });

  this._service.deleteTimesheetByIdFromRemote(timesheetId).subscribe({
    next: (result) => {
      Swal.fire({
        title: 'Deleted!',
        text: 'Timesheet has been deleted.',
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#00c851',
      });

      this.existingMobileTimesheetCards = this.existingMobileTimesheetCards.filter(c =>
        c.timesheetId !== timesheetId && c.id !== card.id
      );

      this.originalMobileCardStates.delete(card);
      
      // Refresh data
      this.getDataByFilterWithPaging();
      this.getDataByFilterWithPagingforexport();
      this.findMainTimesheet();
    },
    error: (error) => {
      console.error('Error deleting timesheet:', error);

      if (error.status === 200 || error.status === 204) {
        Swal.fire({
          title: 'Deleted!',
          text: 'Timesheet has been deleted.',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#00c851',
        });

        this.existingMobileTimesheetCards = this.existingMobileTimesheetCards.filter(c =>
          c.timesheetId !== timesheetId && c.id !== card.id
        );

        this.originalMobileCardStates.delete(card);
        
        // Refresh data
        this.getDataByFilterWithPaging();
        this.getDataByFilterWithPagingforexport();
        this.findMainTimesheet();
      } else {
        Swal.fire({
          title: 'Error',
          text: 'Failed to delete timesheet. Please try again.',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
      }
    }
  });
}

// Update mobile incomplete data for bottom sheet
updateMobileIncompleteData() {
  const periodFrom = moment(this.mainTimesheets.preriodFrom);
  const periodTo = moment(this.mainTimesheets.preriodTo);

  const allDates: Date[] = [];
  let current = periodFrom.clone();

  while (current.isSameOrBefore(periodTo)) {
    const date = current.toDate();
    const dayOfWeek = date.getDay();
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
    const dateStr = current.format('YYYY-MM-DD');

    const isHoliday = this.vacationList.includes(date.getDate());
    const isLeave = false; // Add leave check if needed

    if (!isWeekend && !isHoliday && !isLeave) {
      allDates.push(date);
    }

    current.add(1, 'day');
  }

  const filledDates = this.existingMobileTimesheetCards.map(card =>
    moment(card.dateStr).format('YYYY-MM-DD')
  );

  this.incompleteMobileDates = allDates.filter(date => {
    const dateStr = moment(date).format('YYYY-MM-DD');
    return !filledDates.includes(dateStr);
  });

  this.partialFilledMobileDates = this.existingMobileTimesheetCards.filter(card =>
    card.workingHours < 8
  );
}

  //รวมค่าเดินทาง
  getTotalCost(): number {
    let totalCost = 0;
    this.timesheetexport.forEach((timesheet) => {
      if (timesheet.costOnsite !== null) {
        totalCost += timesheet.costOnsite;
      }
    });
    return totalCost;
  }

  getTotalCostText(): string {
    let totalCost = this.getTotalCost();

    if (totalCost === 0) {
      return "ศูนย์บาทถ้วน";
    }

    const bahtAmount = Math.floor(totalCost);
    const satangAmount = Math.round(totalCost * 100) % 100;

    let totalCostText = `${this.numberToThaiText(bahtAmount)}บาท`;

    if (satangAmount > 0) {
      totalCostText += ` ${this.numberToThaiText(satangAmount)}สตางค์`;
    }

    totalCostText += ".";

    return totalCostText;
  }

  //แปลงตัวเลขเป็นตัวหนังสือ
  numberToThaiText(number: number): string {
    const digits: string[] = [
      "ศูนย์",
      "หนึ่ง",
      "สอง",
      "สาม",
      "สี่",
      "ห้า",
      "หก",
      "เจ็ด",
      "แปด",
      "เก้า",
    ];
    const tens: string[] = [
      "",
      "",
      "ยี่สิบ",
      "สามสิบ",
      "สี่สิบ",
      "ห้าสิบ",
      "หกสิบ",
      "เจ็ดสิบ",
      "แปดสิบ",
      "เก้าสิบ",
    ];
    const teens: string[] = [
      "สิบ",
      "สิบเอ็ด",
      "สิบสอง",
      "สิบสาม",
      "สิบสี่",
      "สิบห้า",
      "สิบหก",
      "สิบเจ็ด",
      "สิบแปด",
      "สิบเก้า",
    ];
    const scales: string[] = ["", "สิบ", "ร้อย", "พัน", "หมื่น"];


    if (number >= 10000) {
      return `${this.numberToThaiText(
        Math.floor(number / 10000)
      )}หมื่น${this.numberToThaiText(number % 10000)}`;
    }
    if (number >= 1000) {
      return `${this.numberToThaiText(
        Math.floor(number / 1000)
      )}พัน${this.numberToThaiText(number % 1000)}`;
    }

    let result = "";
    let chunkCount = 0;

    do {
      const chunk = number % 1000;
      if (chunk !== 0) {
        const chunkText = this.convertChunkToText(chunk, digits, tens, teens);
        result = chunkText + scales[chunkCount] + result;
      }
      number = Math.floor(number / 1000);
      chunkCount++;
    } while (number > 0);

    return result.trim();
  }

  convertChunkToText(
    chunk: number,
    digits: string[],
    tens: string[],
    teens: string[]
  ): string {
    const hundreds = Math.floor(chunk / 100);
    const tensUnits = chunk % 100;

    let result = "";

    if (hundreds > 0) {
      result += digits[hundreds] + "ร้อย";
      if (tensUnits > 0) {
        result += "";
      }
    }

    if (tensUnits >= 20) {
      const tensDigit = Math.floor(tensUnits / 10);
      result += tens[tensDigit];
      const unitsDigit = tensUnits % 10;
      if (unitsDigit > 0) {
        result += "" + digits[unitsDigit];
      }
    } else if (tensUnits >= 10) {
      result += teens[tensUnits - 10];
    } else if (tensUnits > 0) {
      result += digits[tensUnits];
    }

    return result.trim();
  }


  // Edit card functionality methods
startEditingCard(timesheet: any): void {
  if (this.currentEditingCard || timesheet.period) {
    return;
  }

  // Store original state
  this.originalCardStates.set(timesheet, {
    transDate: timesheet.transDate,
    projectName: timesheet.projectName,
    projectId: timesheet.projectId,
    timeFrom: timesheet.timeFrom,
    timeTo: timesheet.timeTo,
    startTime: timesheet.startTime,
    endTime: timesheet.endTime,
    isBreak: timesheet.isBreak,
    checkOnsite: timesheet.checkOnsite,
    projectSites: timesheet.projectSites ? [...timesheet.projectSites] : [],
    siteId: timesheet.siteId,
    siteName: timesheet.siteName,
    costOnsite: timesheet.costOnsite,
    description: timesheet.description,
    workingHours: timesheet.workingHours,
    canAction: timesheet.canAction,
    selectedProject: timesheet.selectedProject,
  });

  // Convert timeFrom and timeTo to time input format (HH:mm)
  if (timesheet.timeFrom) {
    let fromDate = new Date(timesheet.timeFrom);

    if (isNaN(fromDate.getTime())) {
      const timeStr = String(timesheet.timeFrom);
      if (timeStr.includes(":")) {
        const timeParts = timeStr.split(":");
        timesheet.startTime = `${timeParts[0].padStart(
          2,
          "0"
        )}:${timeParts[1].padStart(2, "0")}`;
      } else {
        timesheet.startTime = "";
      }
    } else {
      timesheet.startTime = this.formatTimeForInput(fromDate);
    }
  } else {
    timesheet.startTime = "";
  }

  if (timesheet.timeTo) {
    let toDate = new Date(timesheet.timeTo);

    if (isNaN(toDate.getTime())) {
      const timeStr = String(timesheet.timeTo);
      if (timeStr.includes(":")) {
        const timeParts = timeStr.split(":");
        timesheet.endTime = `${timeParts[0].padStart(
          2,
          "0"
        )}:${timeParts[1].padStart(2, "0")}`;
      } else {
        timesheet.endTime = "";
      }
    } else {
      timesheet.endTime = this.formatTimeForInput(toDate);
    }
  } else {
    timesheet.endTime = "";
  }

  // Find selected project for onsite validation
  if (timesheet.projectName) {
    timesheet.selectedProject = this.projects.find(
      (p) => p.projectName === timesheet.projectName
    );

    // Update projectSites from selectedProject
    if (timesheet.selectedProject?.msProjectSites) {
      timesheet.projectSites = timesheet.selectedProject.msProjectSites;
    }

    // Keep existing siteId if checkOnsite is true
    if (timesheet.checkOnsite) {
      if (
        !timesheet.siteId &&
        timesheet.projectSites &&
        timesheet.projectSites.length > 0
      ) {
        timesheet.siteId =
          timesheet.projectSites[0].id || timesheet.projectSites[0].siteId;
      }
    }
  }

  // Set canAction flag
  timesheet.canAction = !timesheet.period;

  // Set editing state
  timesheet.isEditing = true;
  this.currentEditingCard = timesheet;
}

// Helper method to format time for input
formatTimeForInput(date: Date): string {
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  return `${hours}:${minutes}`;
}

cancelEditingCard(timesheet: any): void {
  // Restore original state
  const originalState = this.originalCardStates.get(timesheet);
  if (originalState) {
    timesheet.transDate = originalState.transDate;
    timesheet.projectName = originalState.projectName;
    timesheet.projectId = originalState.projectId;
    timesheet.timeFrom = originalState.timeFrom;
    timesheet.timeTo = originalState.timeTo;
    timesheet.startTime = originalState.startTime;
    timesheet.endTime = originalState.endTime;
    timesheet.isBreak = originalState.isBreak;
    timesheet.checkOnsite = originalState.checkOnsite;
    timesheet.projectSites = originalState.projectSites;
    timesheet.siteId = originalState.siteId;
    timesheet.siteName = originalState.siteName;
    timesheet.costOnsite = originalState.costOnsite;
    timesheet.description = originalState.description;
    timesheet.workingHours = originalState.workingHours;
    timesheet.canAction = originalState.canAction;
    timesheet.selectedProject = originalState.selectedProject;

    // Remove from map
    this.originalCardStates.delete(timesheet);
  }

  // Clear editing state
  timesheet.isEditing = false;
  this.currentEditingCard = null;
}

saveEditedTimesheet(timesheet: any): void {
  // Validate required fields
  if (!timesheet.projectId) {
    Swal.fire({
      icon: "warning",
      title: "Project Required",
      text: "Please select a project",
      confirmButtonColor: "#3085d6",
    });
    return;
  }

  if (!timesheet.isBreak && (!timesheet.timeFrom || !timesheet.timeTo)) {
    Swal.fire({
      icon: "warning",
      title: "Time Required",
      text: "Please enter start and end time",
      confirmButtonColor: "#3085d6",
    });
    return;
  }

  // Validate onsite requires site selection
  if (timesheet.checkOnsite) {
    const sites = this.getProjectSites(timesheet.projectId);
    if (!sites || sites.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Sites Available",
        text: "This project has no sites available",
        confirmButtonColor: "#3085d6",
      });
      return;
    }
  }

  // Ensure timeFrom and timeTo are proper Date objects
  if (typeof timesheet.timeFrom === "string") {
    const [hours, minutes] = timesheet.timeFrom.split(":");
    const dateObj = new Date(timesheet.transDate);
    dateObj.setHours(parseInt(hours), parseInt(minutes), 0, 0);
    timesheet.timeFrom = dateObj;
  }

  if (typeof timesheet.timeTo === "string") {
    const [hours, minutes] = timesheet.timeTo.split(":");
    const dateObj = new Date(timesheet.transDate);
    dateObj.setHours(parseInt(hours), parseInt(minutes), 0, 0);
    timesheet.timeTo = dateObj;
  }

  // Prepare timesheet data for update
  const updateData = {
    ...timesheet,
    mainTimesheetId: this.maintimesheetId,
    employeeId: this.mainTimesheets.employeeId,
  };

  // Save via service
  this._service.updateTimesheetToRemote(updateData).subscribe({
    next: (response) => {
      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "Timesheet has been updated successfully",
        showConfirmButton: false,
        timer: 1500,
      });

      // Clear editing state
      timesheet.isEditing = false;
      this.currentEditingCard = null;
      this.originalCardStates.delete(timesheet);

      // Refresh data
      setTimeout(() => {
        this.getDataByFilterWithPaging();
        this.getDataByFilterWithPagingforexport();
        this.findMainTimesheet();
        this.calManday();
      }, 500);
    },
    error: (error) => {
      console.error("Error updating timesheet:", error);
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "Failed to update timesheet. Please try again.",
        confirmButtonColor: "#d33",
      });
    },
  });
}

deleteTimesheetConfirm(timesheet: any): void {
  Swal.fire({
    title: "Are you sure?",
    text: "Do you want to delete this timesheet?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel",
  }).then((result) => {
    if (result.isConfirmed) {
      this._service.deleteTimesheetByIdFromRemote(timesheet.id).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Timesheet has been deleted",
            showConfirmButton: false,
            timer: 1500,
          });

          // Clear editing state
          this.currentEditingCard = null;
          this.originalCardStates.delete(timesheet);

          // Refresh data
          setTimeout(() => {
            this.getDataByFilterWithPaging();
            this.getDataByFilterWithPagingforexport();
            this.findMainTimesheet();
            this.calManday();
          }, 500);
        },
        error: (error) => {
          console.error("Error deleting timesheet:", error);
          Swal.fire({
            icon: "error",
            title: "Delete Failed",
            text: "Failed to delete timesheet. Please try again.",
            confirmButtonColor: "#d33",
          });
        },
      });
    }
  });
}

onEditProjectChange(timesheet: any): void {
  // Find project by name and update projectId
  const selectedProject = this.projects.find(
    (p) => p.projectName === timesheet.projectName
  );

  if (selectedProject) {
    timesheet.projectId = selectedProject.id;
    timesheet.selectedProject = selectedProject;

    // Reset onsite settings when project changes
    const sites = selectedProject.msProjectSites || [];
    timesheet.projectSites = sites;

    if (!sites || sites.length === 0) {
      timesheet.checkOnsite = false;
      timesheet.siteId = null;
    } else {
      if (timesheet.checkOnsite) {
        timesheet.siteId = sites[0].id || sites[0].siteId;
      } else {
        timesheet.siteId = null;
      }
    }
  }
}

onEditTimeChange(timesheet: any): void {
  if (!timesheet.startTime || !timesheet.endTime) {
    return;
  }

  // Convert startTime and endTime (HH:mm) to Date objects
  const [startHour, startMin] = timesheet.startTime.split(":").map(Number);
  const [endHour, endMin] = timesheet.endTime.split(":").map(Number);

  const baseDate = new Date(timesheet.transDate);

  const fromTime = new Date(baseDate);
  fromTime.setHours(startHour, startMin, 0, 0);

  const toTime = new Date(baseDate);
  toTime.setHours(endHour, endMin, 0, 0);

  // Update timeFrom and timeTo
  timesheet.timeFrom = fromTime;
  timesheet.timeTo = toTime;

  // Calculate working hours
  let hours = (toTime.getTime() - fromTime.getTime()) / (1000 * 60 * 60);

  // Subtract 1 hour if lunch break is checked
  if (timesheet.isBreak) {
    hours = Math.max(0, hours - 1);
  }

  timesheet.workingHours = Math.max(0, hours);
}

onEditBreakChange(timesheet: any): void {
  // Recalculate working hours when break changes
  this.onEditTimeChange(timesheet);
}

onEditOnsiteChange(timesheet: any): void {
  if (timesheet.checkOnsite) {
    const sites = this.getProjectSites(timesheet.projectId);
    if (sites && sites.length > 0) {
      // Auto-select first site
      timesheet.siteId = sites[0].id || sites[0].siteId;
      timesheet.siteName = sites[0].siteName;
      timesheet.costOnsite = sites[0].siteCost;
    } else {
      // No sites available, uncheck onsite
      timesheet.checkOnsite = false;
      timesheet.siteId = null;
      timesheet.siteName = null;
      timesheet.costOnsite = null;
      Swal.fire({
        icon: "info",
        title: "No Sites Available",
        text: "This project has no onsite locations",
        confirmButtonColor: "#3085d6",
      });
    }
  } else {
    // Clear site selection when unchecked
    timesheet.siteId = null;
    timesheet.siteName = null;
    timesheet.costOnsite = null;
  }
}

onEditSiteChange(timesheet: any, event: any): void {
  const siteId = event.target.value;
  const sites = this.getProjectSites(timesheet.projectId);
  const selectedSite = sites.find((s) => (s.id || s.siteId) == siteId);

  if (selectedSite) {
    timesheet.siteId = selectedSite.id || selectedSite.siteId;
    timesheet.siteName = selectedSite.siteName;
    timesheet.costOnsite = selectedSite.siteCost;
  }
}

      editTimesheet() {
      
    }


  @HostListener("mousemove")
  @HostListener("touchstart")
  ResetTime() {
    this.sessionTimeoutService.ResetTime();
  }
  public findMainTimesheet() {
    this._service
      .findMainTimesheetById(this.maintimesheetId)
      .subscribe((data) => {
        this.mainTimesheets = data;
        console.log(this.mainTimesheets);

        this.firstnameTimesheet = this.mainTimesheets.firstName;
        this.lastnameTimesheet = this.mainTimesheets.lastName;
        this.positionNameTimesheet = this.mainTimesheets.positionName;
        this.getSumCost(this.maintimesheetId);
      });
  }

  private getVacationList() {
    this.calendaService.getMsCalendarAll().subscribe((data) => {
      this.vacationList = data.map(item =>
        moment(item.dayOff).format('YYYY-MM-DD')
      );

      this.isVacationListLoaded = true;
      console.log("Vacation list loaded");
      
      this.checkCountAllTimeSheet();
    });
  }

  getday(date1) {
    return new Date(date1).getDate();
  }

  getday1(date1) {
    return moment(date1).day();
  }

  checkVacation(date: string | Date) {
    // Ensure date is a valid Date object
    const parsedDate = typeof date === "string" ? new Date(date) : date;
    return this.vacationList.some(
      (item) =>
        item === parsedDate.getDate() &&
        parsedDate.getMonth() === this.mainTimesheets.month - 1 &&
        parsedDate.getFullYear() === this.mainTimesheets.year
    );
  }

  checkIsUpdateByManager(updatedBy: string): boolean {
    if (!this.mainTimesheets || !this.mainTimesheets.firstName) {
      return false;
    }
    return updatedBy !== this.mainTimesheets.firstName;
  }
  // || checkIsUpdateByManager(timesheet.updatedBy) === true

  gotoVertify() {
    this.route.navigate(["verify-timesheet"]);
  }

  calManday() {
    this._service
      .sumWorkingHoursByName(this.maintimesheetId, this.currentSearch)
      .subscribe((result) => {
        this.manday = result / 8;
      });
  }

  // getProjectName() {
  //   this._service.getProjectNameByMainTimesheetId(this.maintimesheetId).subscribe((res) => {
  //     this.projectNames = res;
  //     this.currentTabProject = res[0];
  //   })
  // }

  formatTime(time) {
    return moment(time, "HH:mm:ss").format("HH:mm");
  }

  filterByDateRange(data: any[]): any[] {
    if (!this.searchStartDateValue && !this.searchEndDateValue) {
      return data;
    }

    return data.filter(timesheet => {
      const transDate = moment(timesheet.transDate);

      if (this.searchStartDateValue) {
        const startDate = moment(this.searchStartDateValue, "DD/MM/YYYY");
        if (transDate.isBefore(startDate, 'day')) {
          return false;
        }
      }

      if (this.searchEndDateValue) {
        const endDate = moment(this.searchEndDateValue, "DD/MM/YYYY");
        if (transDate.isAfter(endDate, 'day')) {
          return false;
        }
      }

      return true;
    });
  }

  getDataByFilterWithPaging() {
    var date = "";

    if (this.searchDate != "") {
      date = moment(this.searchDate, ["DD/MM/YYYY", "YYYY-MM-DD"]).format(
        "YYYY-MM-DD"
      );
    }


    if (this.searchStartDateValue || this.searchEndDateValue) {
      console.log("Using date range filter:", this.searchStartDateValue, "to", this.searchEndDateValue);
      date = ""; 
    }

    this._service
      .getTimesheetByMainTimesheetAndProjectNameWithPaging(
        this.currentPage,
        this.pageSize,
        this.maintimesheetId,
        this.currentTabProject,
        this.searchStartTime,
        this.searchEndTime,
        date,
        this.colSort,
        this.booleanValue
      )
      .subscribe((data) => {
        data.allProjectName.unshift("Total");
        this.projectNames = data.allProjectName;
        if (this.currentTabProject == "") {
          this.currentTabProject = data.allProjectName[0];
        }

        // กรองข้อมูลตาม date range ฝั่งหน้าบ้าน
        let filteredData = data.data;
        if (this.searchStartDateValue || this.searchEndDateValue) {
          filteredData = this.filterByDateRange(data.data);
        }

        this.timesheets = filteredData;
        this.pagingLength = data.totalPage;
        this.manday = data.sumWorkingHours / 8.0;
      });
  }

  counter(i: number) {
    return new Array(i);
  }

  changePage(page: number) {
    this.currentPage = page;
    this.startIndex = this.currentPage * 10;
    this.getDataByFilterWithPaging();
    this.findMainTimesheet();
  }


  //Pagination

  // previousClick() {
  //   if (this.currentSelectedPage > 0) {
  //     this.currentSelectedPage--;
  //     this.getDataByFilterWithPaging();
  //   }
  // }

  // nextClick() {
  //   if (this.currentSelectedPage < this.totalPages - 1) {
  //     this.currentSelectedPage++;
  //     this.getDataByFilterWithPaging();
  //   }
  // }

  getPaginationWithIndex(index: number) {
    this.currentSelectedPage = index;
    this.getDataByFilterWithPaging();
  }

  active(index: number) {
    if (this.currentSelectedPage == index) {
      return {
        active: true,
      };
    } else {
      return {
        active: false,
      };
    }
  }

  getSearchFilter() {
    console.log("Search triggered with date range:", this.searchStartDateValue, "to", this.searchEndDateValue);
    this.currentPage = 0; // Reset to first page when searching
    this.startIndex = 0;
    this.getDataByFilterWithPaging();
    this.getDataByFilterWithPagingforexport(); // Update export data too
    this.findMainTimesheet();
    this.calManday();
  }

  deleteTimesheet(id: number) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          "Deleted!",
          "Your imaginary file has been deleted.",
          "success"
        );
        return this._service.deleteTimesheetByIdFromRemote(id).subscribe(
          (success) => {
            ("Product deleted succesfully");
          },
          (error) => {
            this.getDataByFilterWithPaging();
          }
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Your imaginary file is safe :)", "error");
      }
      return false;
    });
  }
  goToUpdateTimesheet(tid: number) {
    this.route.navigate(["/edit-timesheet", tid]);
  }

  onCloseModel() {
    this.reason = "";
    this.closebutton.nativeElement.click();
  }

  onClickReject(rejectsentMainTimesheet: MainTimesheet) {
  this.selectreject = rejectsentMainTimesheet;
  Swal.fire({
    title: "Are you sure to reject?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, Reject it!",
  }).then((result) => {
    if (result.isConfirmed) {
      // ส่งเมลหลัก
      this.userService
        .sendEmailForApproveTimeSheet(
          rejectsentMainTimesheet.id,
          rejectsentMainTimesheet.employeeId,
          "R"
        )
        .subscribe((data) => {
          this.invalidEmail = false;
        });

      // ถ้า employeeId = 183 ให้ส่งเมลเพิ่มอีกคน (185)
      if (rejectsentMainTimesheet.employeeId === 183) {
        this.userService
          .sendEmailForApproveTimeSheet(
            rejectsentMainTimesheet.id,
            303,
            "R"
          )
          .subscribe();
      }

      Swal.fire("Reject!", "Your data has been Reject.", "success");
      this.selectreject = rejectsentMainTimesheet;
      this.selectreject.status = "R";
      this.service.updateMainTimesheet(this.selectreject).subscribe(
        (data) => {},
        (error) => {}
      );
      this.gotoVerifyByButton("rejected");
    }
  });
}


   onClickRevise(MainTimesheet: MainTimesheet) {
      if (!this.checkIsReason()) {
        return;
      }
  
      Swal.fire({
      title: "Are you sure to revise?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#007bff",
      cancelButtonColor: "#E5E5EA",
      confirmButtonText: "Yes, Revise it!",
      customClass: {
        confirmButton: "custom-swal-button",
        cancelButton: "custom-swal-button",
        },
      }).then((result) => {
        if (result.isConfirmed) {
  
          MainTimesheet.status = "V";   
          MainTimesheet.reason = this.reason;
          MainTimesheet.revise = "1";
  
          this.service.updateMainTimesheet(MainTimesheet)
            .subscribe((data) => {
              this.route.navigate(["/verify-timesheet"]);
              console.log(data);
              this.modalService.dismissAll();
              this.reason = "";
              this.userService
                .sendMailTimesheet(
                  MainTimesheet.id,
                  MainTimesheet.employeeId,
                  MainTimesheet.status
                )
                .subscribe((res) => {
                  console.log(res);
                });
            });
        }
    });
  }

  onClickApprove(rejectsentMainTimesheet: MainTimesheet) {
  console.log("rejectsentMainTimesheet:", rejectsentMainTimesheet);

  Swal.fire({
    title: "Are you sure to approve?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#007bff",
    cancelButtonColor: "#E5E5EA",
    confirmButtonText: "Yes, Approve it!",
    customClass: {
      confirmButton: "custom-swal-button",
      cancelButton: "custom-swal-button",
    },
  }).then((result) => {
    if (!result.isConfirmed) return;

    this.service
      .checkMandayTimesheet(rejectsentMainTimesheet.id)
      .subscribe((res) => {
        this.checkMandayProject = res;

        const requests = this.checkMandayProject.map((element) =>
          this.projectService
            .getProjectRemainingManday(element.projectId)
            .pipe(
              map((projectData) => ({
                ...projectData,
                projectManday: element.projectManday,
              }))
            )
        );

        if (requests.length === 0) {
          console.log("No manday data, skip check → processApproval");
          this.processApproval(rejectsentMainTimesheet);
          return;
        }

        forkJoin(requests).subscribe((results) => {
          this.projectRemainingManday = results;
          this.checkProjectManday = [];

          this.projectRemainingManday.forEach((element) => {
            const {
              id,
              projectName,
              manday,
              remainingManday,
              projectManday,
            } = element;

            if (!manday) return;

            const actualRemaining = remainingManday ?? manday;
            const calManday = actualRemaining - projectManday;

            if (calManday < 0) {
              this.checkProjectManday.push({
                id,
                projectName,
                manday,
                remainingManday,
                projectManday,
                calManday,
              });
            }
          });

          if (this.checkProjectManday.length > 0) {
            const projectDetails = this.checkProjectManday
              .map((p) => `${p.projectName}: ${p.calManday} manday`)
              .join("<br>");

            Swal.fire({
              icon: "error",
              title: "Project manday is not enough!",
              html: projectDetails,
            });
            return; 
          }

          this.processApproval(rejectsentMainTimesheet);
        });
      });
  });
}

private processApproval(rejectsentMainTimesheet: MainTimesheet) {
  console.log("Enter ProcessApproval")
  rejectsentMainTimesheet.status = "A";
  console.log("Status : ", rejectsentMainTimesheet.status)

  this.selectreject = rejectsentMainTimesheet;


  this.service.updateMainTimesheet(this.selectreject).subscribe({
    next: () => {
      console.log("Timesheet updated successfully");

      if (this.selectreject.status === "A" && this.selectreject.reviseBy != null) {
        this.userService
          .sendMailTimesheet(
            rejectsentMainTimesheet.id,
            rejectsentMainTimesheet.employeeId,
            "M"
          )
          .subscribe();
      } else if (this.selectreject.status === "A") {
        this.userService
          .sendEmailForApproveTimeSheet(
            rejectsentMainTimesheet.id,
            rejectsentMainTimesheet.employeeId,
            "A"
          )
          .subscribe();
      }

      Swal.fire({
        title: "Approve!",
        text: "Your data has been approved.",
        icon: "success",
      }).then(() => {
        this.route.navigate(["/verify-timesheet"]);
      });
    },
    error: (error) => {
      console.error("Error updating timesheet:", error);
      Swal.fire({
        title: "เกิดข้อผิดพลาด!",
        text: "ไม่สามารถอัปเดตสถานะได้",
        icon: "error",
      });
    },
  });
}

  gotoVerifyByButton(A) {
    Swal.fire({
      title: A + "!",
      text: "Your data has been " + A + ".",
      icon: "success",
    }).then(() => {
      this.route.navigate(["/verify-timesheet"]);
    });
  }



// Key changes to verify-timesheet-view.component.ts

// 1. Change HR Revise status from 'V' to 'H'
  checkIsReason(): boolean {
    if (!this.reason || this.reason.trim() === '') {
      this.isReasonInvalid = true;
      return false;
    }
    this.isReasonInvalid = false;
    return true;
  }

  onClickHrRevise(MainTimesheet: MainTimesheet) {
      if (!this.checkIsReason()) {
        return; 
      }
      console.log(this.isReasonInvalid)
      Swal.fire({
        title: "Are you sure to revise?",
        // text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#007bff",
        cancelButtonColor: "#E5E5EA",
        confirmButtonText: "Yes, Revise it!",
        customClass: {
          confirmButton: "custom-swal-button",
          cancelButton: "custom-swal-button",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          MainTimesheet.status = "H";
          MainTimesheet.reason = this.reason;
          MainTimesheet.revise = "1";
          MainTimesheet.reviseBy = Number(this.userId);
          this.service.updateMainTimesheet(MainTimesheet).subscribe((data) => {
            console.log(data);
            this.modalService.dismissAll();
            this.reason = "";
            this.userService
              .sendMailTimesheet(
                MainTimesheet.id,
                MainTimesheet.employeeId,
                MainTimesheet.status
              )
              .subscribe((data) => {
                console.log(data);
              });
          });
        }
        this.route.navigate(["/verify-timesheet"]);
      });
  }

// 2. Change default sort to DESC for transDate
ngOnInit(): void {
  // Check if mobile view
  this.existingMobileTimesheetCards = []
  this.checkMobileView();
  
  // Set default sort to DESC
  this.booleanValue = false; // false = DESC, true = ASC
  this.colSort = "transDate"; // Sort by date
  
  // Original code
  this.getDataByFilterWithPaging();
  this.findMainTimesheet();
  this.getVacationList();
  this.getDataByFilterWithPagingforexport();
  this.sessionTimeoutService.ResetTime();
  this.roleId = JSON.parse(localStorage.getItem("role"));
  this.getAllProjects();

  this.cancelMobileAddForm()
  
  // Listen for window resize
  window.addEventListener('resize', () => this.checkMobileView());
}

// Update the sort method to handle initial DESC sort
sort(colName, boolean) {
  this.colSort = colName;
  if (boolean == true) {
    this.getDataByFilterWithPaging();
    this.findMainTimesheet();
    this.booleanValue = !this.booleanValue;
  } else {
    this.getDataByFilterWithPaging();
    this.findMainTimesheet();
    this.booleanValue = !this.booleanValue;
  }
}

// Ensure DESC sort is maintained when changing projects
changeProject(projectName: string) {
  this.currentTabProject = projectName;
  this.currentPage = 0;
  this.startIndex = 0;
  this.currentSelectedPage = 0;
  this.selectedPage = 0;
  // Keep DESC sort
  this.colSort = "transDate";
  this.booleanValue = false; // DESC
  this.getDataByFilterWithPaging();
  this.findMainTimesheet();
}

// Update clear search to maintain DESC sort
onClearSearch() {
  this.searchStartTime = "00:00";
  this.searchEndTime = "23:59";

  var startTimeInput = document.getElementById(
    "tmpStartTime"
  ) as HTMLInputElement | null;
  if (startTimeInput) {
    startTimeInput.value = "";
  }
  var endTimeInput = document.getElementById(
    "tmpEndTime"
  ) as HTMLInputElement | null;
  if (endTimeInput) {
    endTimeInput.value = "";
  }

  this.searchStartDateValue = "";
  this.searchEndDateValue = "";
  this.searchStartDate = "";
  this.searchEndDate = "";
  this.searchDate = "";

  this.isSearch = false;
  this.currentPage = 0;
  this.colSort = "transDate";
  this.booleanValue = false; // DESC sort
  this.startIndex = 0;
  this.getDataByFilterWithPaging();
  this.getDataByFilterWithPagingforexport();
  this.findMainTimesheet();
  this.calManday();

  console.log("Search filters cleared with DESC sort");
}

// Auto-expand textarea as user types
autoExpandTextarea(event: any) {
  const textarea = event.target;
  textarea.style.height = 'auto'; // Reset height
  textarea.style.height = textarea.scrollHeight + 'px'; // Set to scroll height
}

// Load existing timesheets for mobile - with DESC date sort
loadExistingTimesheetsForMobile() {
  this.existingMobileTimesheetCards = []
  
  if (!this.mainTimesheets || !this.mainTimesheets.preriodFrom || !this.mainTimesheets.preriodTo) {
    console.warn('MainTimesheets not loaded yet, retrying...');
    setTimeout(() => this.loadExistingTimesheetsForMobile(), 500);
    return;
  }

  this._service
    .getTimesheetByMainTimesheetAndProjectNameWithPaging(
      0,
      999999,
      this.maintimesheetId,
      '',
      '00:00',
      '23:59',
      '',
      'transDate',
      false  // false = DESC sort (most recent first)
    )
    .subscribe((data) => {
      console.log('Mobile timesheets data:', data);
      
      const allTimesheets: any[] = data.data || [];

      const periodFrom = moment(this.mainTimesheets.preriodFrom).startOf('day');
      const periodTo = moment(this.mainTimesheets.preriodTo).endOf('day');

      const filteredTimesheets = allTimesheets.filter(ts => {
        const transDate = moment(ts.transDate);
        return transDate.isSameOrAfter(periodFrom) && transDate.isSameOrBefore(periodTo);
      });

      console.log('Filtered timesheets for mobile:', filteredTimesheets);

      this.existingMobileTimesheetCards = filteredTimesheets.map((ts, idx) => {
        const selectedProject = this.projects.find(p => p.id === ts.projectId || p.projectName === ts.projectName);

        let startTime = '09:00';
        let endTime = '18:00';

        if (ts.timeFrom) {
          try {
            const parsed = moment(ts.timeFrom, "HH:mm");
            if (parsed.isValid()) {
              startTime = parsed.format('HH:mm');
            } else {
              const parsedISO = moment(ts.timeFrom);
              if (parsedISO.isValid()) {
                startTime = parsedISO.format('HH:mm');
              }
            }
          } catch (e) {
            console.error('Error parsing timeFrom:', ts.timeFrom, e);
          }
        }

        if (ts.timeTo) {
          try {
            const parsed = moment(ts.timeTo, "HH:mm");
            if (parsed.isValid()) {
              endTime = parsed.format('HH:mm');
            } else {
              const parsedISO = moment(ts.timeTo);
              if (parsedISO.isValid()) {
                endTime = parsedISO.format('HH:mm');
              }
            }
          } catch (e) {
            console.error('Error parsing timeTo:', ts.timeTo, e);
          }
        }

        return {
          id: `existing_${idx}`,
          date: new Date(ts.transDate),
          dateStr: moment(ts.transDate).format('YYYY-MM-DD'),
          projectName: ts.projectName,
          projectId: ts.projectId,
          startTime: startTime,
          endTime: endTime,
          workingHours: ts.workingHours,
          isBreak: ts.isBreak || false,
          checkOnsite: ts.checkOnsite || false,
          siteId: ts.siteId || null,
          description: ts.description || '',
          projectSites: selectedProject?.msProjectSites || [],
          selectedProject: selectedProject || null,
          isReadOnly: true,
          timesheetId: ts.id,
          canAction: this.mainTimesheets.status === 'H'
        };
      });

      console.log('Existing mobile timesheet cards:', this.existingMobileTimesheetCards);
    }, error => {
      console.error("Error loading existing timesheets:", error);
      this.existingMobileTimesheetCards = [];
    });
}


  gotoHomepage() {
    this.route.navigate(["/verify-timesheet"]);
  }

  printText(data) {
    if (data == null || data == "") {
      return "";
    } else {
      return data.toString();
    }
  }

  printHighlight(data) {
    if (data == null || data == "") {
      return "";
    } else {
      return data.replace(
        new RegExp(this.currentSearch, "gi"),
        (match) => "<mark>" + match + "</mark>"
      );
    }
  }

  setStartTime(e: any) {
    this.searchStartTime = e;
  }
  setEndTime(e: any) {
    this.searchEndTime = e;
  }

  setStartDate(e: any) {
    this.searchStartDateValue = this.formatDate(e);
    console.log("setstartdate ::: ", this.searchStartDateValue);
  }

  setEndDate(e: any) {
    this.searchEndDateValue = this.formatDate(e);
    console.log("setenddate ::: ", this.searchEndDateValue);
  }

  formatDate(date) {
    return moment(date, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("DD/MM/YYYY");
  }

  setDate(e: any) {
    this.searchDate = this.formatDate(e);
  }
  //export excel
  getDataByFilterWithPagingforexport() {
    var date = "";

    // กรณีใช้ single date
    if (this.searchDate != "") {
      date = moment(this.searchDate, ["DD/MM/YYYY", "YYYY-MM-DD"]).format(
        "YYYY-MM-DD"
      );
    }

    // กรณีใช้ date range - ไม่ส่ง date parameter เพื่อให้ได้ข้อมูลทั้งหมด
    if (this.searchStartDateValue || this.searchEndDateValue) {
      console.log("Using date range for export:", this.searchStartDateValue, "to", this.searchEndDateValue);
      date = ""; // ไม่ส่ง date เพื่อให้ได้ข้อมูลทั้งหมด
    }

    this._service
      .getTimesheetByMainTimesheetAndProjectNameWithPaging(
        this.currentPage,
        this.pageSizeforexport,
        this.maintimesheetId,
        this.currentTabProject,
        this.searchStartTime,
        this.searchEndTime,
        date,
        this.colSort,
        this.booleanValue
      )
      .subscribe((data) => {
        data.allProjectName.unshift("Total");
        this.projectNames = data.allProjectName;
        if (this.currentTabProject == "") {
          this.currentTabProject = data.allProjectName[0];
        }

        // กรองข้อมูลตาม date range สำหรับ export
        let filteredData = data.data;
        if (this.searchStartDateValue || this.searchEndDateValue) {
          filteredData = this.filterByDateRange(data.data);
        }

        this.timesheetexport = filteredData;
        // this.pagingLength = data.totalPage;
        this.manday = data.sumWorkingHours / 8.0;

        this.isExportDataLoaded = true;
        console.log("Export data loaded");

        // Try to run validation if all data is ready
        this.tryRunValidation();
      });
  }

  // Try to run validation only when all data is ready
  private tryRunValidation() {
    console.log("Try run validation - vacation:", this.isVacationListLoaded, "export:", this.isExportDataLoaded);

    // Only run validation when both vacation list and export data are loaded
    if (this.isVacationListLoaded && this.isExportDataLoaded) {
      console.log("All data ready - running validation");
      this.checkCountAllTimeSheet();
    }
  }

  // Check incomplete timesheet days - for validation
  checkCountAllTimeSheet() {
    if (!this.mainTimesheets || !this.mainTimesheets.month || !this.mainTimesheets.year) {
      console.log("Main timesheet data not ready yet");
      return;
    }

    // Calculate work dates for the timesheet period
    this.workDate = [];
    const month = this.mainTimesheets.month;
    const year = this.mainTimesheets.year;

    let startDate: moment.Moment;
    let endDate: moment.Moment;

    if (month === 1) {
      // มกราคม: 1-25 มกราคม
      startDate = moment().year(year).month(0).date(1);
      endDate = moment().year(year).month(0).date(25);
    } else if (month === 13) {
      // เดือน 13: 26-31 ธันวาคม
      startDate = moment().year(year).month(11).date(26);
      endDate = moment().year(year).month(11).date(31);
    } else {
      // เดือนอื่นๆ: 26 เดือนก่อน ถึง 25 เดือนปัจจุบัน
      startDate = moment().year(year).month(month - 2).date(26);
      endDate = moment().year(year).month(month - 1).date(25);
    }

    // Generate work dates (excluding weekends and holidays)
    let currentDate = startDate.clone();
    while (currentDate.isSameOrBefore(endDate)) {
      const dayOfWeek = currentDate.day();
      const isWeekend = dayOfWeek === 0 || dayOfWeek === 6; // Sunday = 0, Saturday = 6

      const currentDateStr = currentDate.format('YYYY-MM-DD');
      const isHoliday = this.vacationList.includes(currentDateStr);

      if (isHoliday) {
        console.log('HOLIDAY:', currentDateStr);
    }
      // เฉพาะวันทำงาน (ไม่ใช่วันหยุดสุดสัปดาห์และไม่ใช่วันหยุดนักขัตฤกษ์)
      if (!isWeekend && !isHoliday) {
        this.workDate.push({
          year: currentDate.year(),
          month: currentDate.month() + 1,
          date: currentDate.date()
        });
      }

      currentDate.add(1, 'day');
    }

    console.log("Work dates:", this.workDate);

    // Calculate working hours by date
    const workingHoursByDate = new Map<string, number>();

    this.timesheetexport.forEach((timesheet) => {
      const date = timesheet.transDate instanceof Date
        ? timesheet.transDate
        : new Date(timesheet.transDate);
      const dateKey = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      const currentHours = workingHoursByDate.get(dateKey) || 0;
      workingHoursByDate.set(dateKey, currentHours + timesheet.workingHours);
    });

    console.log("Working hours by date:", workingHoursByDate);

    // Filter dates that either have no timesheet OR have less than 8 hours
    this.dateNotYet = this.workDate.filter((workdate) => {
      const dateKey = `${workdate.year}-${workdate.month}-${workdate.date}`;
      const totalHours = workingHoursByDate.get(dateKey) || 0;

      // Include if no timesheet entry OR if total working hours < 8
      return totalHours < 8;
    });

    console.log("DATE NOT YET (incomplete days):", this.dateNotYet);

    // Separate by this month and last month
    if (month <= 12) {
      this.dateNotYetThisMonth = this.dateNotYet.filter(
        (date) => date.month == month
      );
      this.dateNotYetLastMonth = this.dateNotYet.filter(
        (date) => date.month != month
      );
    } else {
      this.dateNotYetThisMonth = this.dateNotYet.filter(
        (date) => date.month == 12
      );
      this.dateNotYetLastMonth = [];
    }

    console.log("Date not yet this month:", this.dateNotYetThisMonth);
    console.log("Date not yet last month:", this.dateNotYetLastMonth);

    // Check if submit button should be disabled
    this.checkSubmitValidation();
  }

  // Check if Submit button should be enabled or disabled
  checkSubmitValidation() {
    const positionId = this.mainTimesheets.positionId;

    // Special case: Positions 21, 22, 23 can always submit
    // MS_POSITION.ID = 21 (Account Executive), 22 (Solution Consultant), 23 (Solution Consultant Manager)
    if (positionId === 21 || positionId === 22 || positionId === 23) {
      this.isSubmitBtnDisabled = true; // Can submit (button enabled)
      console.log("Position 21/22/23 - can submit");
      return;
    }

    // For other positions:
    // If there are any incomplete days (not filled or less than 8 hours), cannot submit
    const hasMissingDates = this.dateNotYet && this.dateNotYet.length > 0;

    if (hasMissingDates) {
      this.isSubmitBtnDisabled = false; // Cannot submit (button disabled)
      console.log("Has incomplete days - cannot submit");
      return;
    }

    // If all days are filled with 8+ hours, can submit
    this.isSubmitBtnDisabled = true; // Can submit (button enabled)
    console.log("All conditions met - can submit");
  }

  // Export Report cost
  @ViewChild("tableReportCost") table: ElementRef;
  exportCost() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    );

    ws["!cols"] = [
      { width: 5 }, // กำหนดความกว้างของคอลัมน์ A เป็น 100
      { width: 12 }, // กำหนดความกว้างของคอลัมน์ B เป็น 100
      { width: 30 }, // กำหนดความกว้างของคอลัมน์ C เป็น 150
      { width: 20 }, // กำหนดความกว้างของคอลัมน์ D เป็น 100
      { width: 20 }, // กำหนดความกว้างของคอลัมน์ E เป็น 100
      { width: 20 }, // กำหนดความกว้างของคอลัมน์ D เป็น 100
      { width: 10 }, // กำหนดความกว้างของคอลัมน์ F เป็น 150 (C6)
      { width: 10 },
      { width: 20 },
    ];
    ws["!cols"][0] = { width: 6 };
    ws["!cols"][1] = { width: 10 };
    ws["!cols"][6] = { width: 15 };
    ws["!cols"][7] = { width: 10 };

    ws.A1.s = {
      alignment: { horizontal: "center" },
      font: { bold: true, sz: 18 },
    };
    ws.A2.s = {
      alignment: { horizontal: "center" },
      font: { bold: true, sz: 12 },
    };
    // ws.A4.s = {
    //   alignment: { horizontal: "center" },
    //   font: { bold: true, sz: 12 },
    // };
    // ws.A6.s = {
    //   alignment: { horizontal: "left" },
    //   font: { bold: true, sz: 12 },
    // };
    // ws.F4.s = {
    //   alignment: { horizontal: "left" },
    //   font: { bold: true, sz: 12 },
    // };
    // ws.F6.s = {
    //   alignment: { horizontal: "left" },
    //   font: { bold: true, sz: 12 },
    // };

    ws.C4.s = {
      alignment: { horizontal: "center" },
      font: { bold: false, sz: 12 },
    };
    ws.C6.s = {
      alignment: { horizontal: "center" },
      font: { bold: false, sz: 12 },
    };
    ws.G4.s = {
      alignment: { horizontal: "center" },
      font: { bold: false, sz: 12 },
    };
    ws.G6.s = {
      alignment: { horizontal: "center" },
      font: { bold: false, sz: 12 },
    };
    // ws.G33.s = {
    //   alignment: { horizontal: "right" },
    //   font: { bold: false, sz: 12 },
    // };
    ws.A8.s = {
      alignment: { horizontal: "center" },
      font: { bold: true, sz: 12 },
    };
    ws.B8.s = {
      alignment: { horizontal: "center" },
      font: { bold: true, sz: 12 },
    };
    ws.C8.s = {
      alignment: { horizontal: "center" },
      font: { bold: true, sz: 12 },
    };
    ws.D8.s = {
      alignment: { horizontal: "center" },
      font: { bold: true, sz: 12 },
    };
    ws.E8.s = {
      alignment: { horizontal: "center" },
      font: { bold: true, sz: 12 },
    };
    ws.F8.s = {
      alignment: { horizontal: "center" },
      font: { bold: true, sz: 12 },
    };
    ws.G8.s = {
      alignment: { horizontal: "center" },
      font: { bold: true, sz: 12 },
    };
    ws.H8.s = {
      alignment: { horizontal: "center" },
      font: { bold: true, sz: 12 },
    };
    ws.I8.s = {
      alignment: { horizontal: "center" },
      font: { bold: true, sz: 12 },
    };

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report cost");

    XLSX.writeFile(wb, "Report Cost.xlsx");
  }

  getSumCost(id: number) {
    this.mainTimesheetService.getSumCost(id).subscribe((data) => {
      this.sumCost = data;
      console.log("sumCost :::: ", this.sumCost);
    });
  }

  goToEditTimesheet(content: any) {
    this.modalService
      .open(content, {
        ariaLabelledBy: "modal-basic-title",
        size: "lg",
        windowClass: "zinfexFixed",
      })
      .result.then(
        (res) => {
          // ------ กดปุ่ม Close ------
          this.closeModal = `Closed with: ${res}`;
        },
        (res) => {
          // ------ Action ตอนกด Esc หรือกดออกเองแบบไม่กดปุ่ม Close ------
          this.closeModal = `Dismissed ${this.getDismissReason(res)}`;
        }
      );
    // this.route.navigate(["/edit-timesheet", tid]);
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }



  onClickPendingHrApprove(MainTimesheet: MainTimesheet) {
    Swal.fire({
      title: "Are you sure to submit?",
      // text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
    }).then((result) => {
      if (result.isConfirmed) {
        MainTimesheet.status = "M";
        MainTimesheet.reviseBy = Number(this.userId);

        this.service.updateMainTimesheet(MainTimesheet).subscribe((data) => {
          this.userService
            .sendMailTimesheet(
              MainTimesheet.id,
              MainTimesheet.employeeId,
              MainTimesheet.status
            )
            .subscribe((data) => {
              console.log(data);
            });

          this.gotoVerifyByButton("submit");
        });
      }
    });
  }

  openDiaLogClick(content: any) {
    this.modalService.open(content, {
      size: "lg",
      centered: true,
      windowClass: "zinfexFixed",
    });
  }

  goToAddTimesheet(mainTimesheet: any) {
    this.route.navigate(
      [
        "add-timesheet",
        this.maintimesheetId,
        mainTimesheet.month,
        mainTimesheet.year
      ],
    );
    sessionStorage.setItem('checkPage', 'add-timesheet-detail');
    sessionStorage.setItem("empid", mainTimesheet.employeeId);
  }

  getProjectSites(projectId: number): any[] {
    const project = this.projects?.find(p => p.id === projectId);
    return project?.msProjectSites || [];
  }
  
    getSelectedSiteName(timesheet: any): string {
    console.log("timesheet", timesheet);
    if (timesheet.projectSites && timesheet.projectSites.length > 0) {
      
      return timesheet.projectSites[0].siteName || '';
    }

    const projectSites = this.getProjectSites(timesheet.projectId);

    return projectSites.length > 0 ? projectSites[0].siteName || '' : '';
  }

  getSelectedSiteCost(timesheet: any): string | number {
    if (timesheet.projectSites && timesheet.projectSites.length > 0) {
      console.log("timesheet.projectSites[0].siteCost", timesheet.projectSites[0].siteCost);
      return timesheet.projectSites[0].siteCost || '';
    }

    const projectSites = this.getProjectSites(timesheet.projectId);
    return projectSites.length > 0 ? projectSites[0].siteCost || '' : '';
  }

  private getAllProjects() {
    this.projectService.getProjectAll().subscribe((data) => {
      this.projects = data;
      // Run validation immediately after projects are loaded (like list-by-month)
      this.checkCountAllTimeSheet();
    });
  }

  // Handle native date input changes
  onStartDateChange(event: any) {
    if (this.searchStartDate) {
      this.searchStartDateValue = this.formatDate(this.searchStartDate);
      console.log("Start date changed:", this.searchStartDateValue);
    } else {
      this.searchStartDateValue = "";
    }
  }

  onEndDateChange(event: any) {
    if (this.searchEndDate) {
      this.searchEndDateValue = this.formatDate(this.searchEndDate);
      console.log("End date changed:", this.searchEndDateValue);
    } else {
      this.searchEndDateValue = "";
    }
  }

  // Handle text date input changes
  onStartDateTextChange(event: any) {
    // User types text directly, just store it
    this.searchStartDateValue = this.searchStartDate;
    console.log("Start date changed:", this.searchStartDateValue);
  }

  onEndDateTextChange(event: any) {
    // User types text directly, just store it
    this.searchEndDateValue = this.searchEndDate;
    console.log("End date changed:", this.searchEndDateValue);
  }

  maxVisiblePages: number = 10;

  get pages(): number[] {
    const startPage = Math.floor(this.currentPage / 10) * 10 + 1;
    const endPage = Math.min(startPage + 9, this.pagingLength);
    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  }

  visiblePages(): number[] {
    const pages = [];
    let startPage = Math.max(
      1,
      this.currentPage - Math.floor(this.maxVisiblePages / 2)
    );
    let endPage = startPage + this.maxVisiblePages - 1;

    if (endPage > this.pagingLength) {
      endPage = this.pagingLength;
      startPage = Math.max(1, endPage - this.maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  }

  setPage(page: number): void {
    if (page < 0 || page > this.pagingLength) return;

    this.currentPage = page;
    this.startIndex = this.currentPage * 10;
    this.getDataByFilterWithPaging();
  }
}
